<template>
  <div class="v-file-input" :class="{ 'v-file-input--invalid': invalid }">
    <label v-if="label" class="v-file-input__label">{{ label }}</label>

    <div class="v-file-input__wrapper">
      <input ref="fileInput" type="file" :accept="accept" :multiple="false" @change="handleFileChange"
        class="v-file-input__input" />

      <div class="v-file-input__upload-label">{{ 'activities.add_photo' | translate }}</div>

      <div class="v-file-input__display" @click="triggerFileInput">
        <span class="v-file-input__button">
          <template v-if="selectedFiles.length && previews[0]">
            <img :src="previews[0]" class="v-file-input__inline-preview" />
            <button class="v-file-input__remove-button" @click.stop="removeFile(0)" type="button">
              <i class="i-util-close"></i>
            </button>
          </template>
          <template v-else>
            <span class="v-file-input__button-text">
              {{ placeholder || 'Вибрати' }}
            </span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM7 10L6.29289 9.29289L11.2929 4.29289L12 5L12.7071 5.70711L7.70711 10.7071L7 10ZM12 5L12.7071 4.29289L17.7071 9.29289L17 10L16.2929 10.7071L11.2929 5.70711L12 5ZM12 5L13 5L13 14L12 14L11 14L11 5L12 5Z"
                fill="black" />
              <path d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16" stroke="black"
                stroke-width="2" />
            </svg>

          </template>
        </span>
      </div>
    </div>

    <div v-if="hint" class="v-file-input__hint" :class="{ 'v-file-input__hint--error': invalid }">
      {{ hint }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VFileInput',

  props: {
    value: {
      type: File,
      default: null
    },
    label: String,
    placeholder: String,
    hint: String,
    invalid: Boolean,
    accept: {
      type: String,
      default: 'image/*'
    }
  },

  data () {
    return {
      selectedFiles: [],
      previews: []
    }
  },

  watch: {
    value: {
      handler (newValue) {
        if (newValue instanceof File) {
          this.selectedFiles = [newValue]
          this.previews = [URL.createObjectURL(newValue)]
        } else {
          this.clearData()
        }
      },
      immediate: true
    }
  },

  methods: {
    triggerFileInput () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },

    handleFileChange (event) {
      const file = event.target.files[0]
      if (file && file.type.startsWith('image/')) {
        this.selectedFiles = [file]
        this.previews = [URL.createObjectURL(file)]
        this.$emit('input', file)
        this.$emit('change', [file])
      }
    },

    removeFile (index) {
      const preview = this.previews.splice(index, 1)[0]
      if (preview) {
        URL.revokeObjectURL(preview)
      }
      this.selectedFiles.splice(index, 1)

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }

      this.$emit('input', null)
    },

    clearData () {
      this.selectedFiles = []
      this.previews.forEach(p => p && URL.revokeObjectURL(p))
      this.previews = []
      this.$emit('input', null)
    },

    clear () {
      this.clearData()

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    }
  },

  beforeDestroy () {
    this.previews.forEach(p => p && URL.revokeObjectURL(p))
  }
}
</script>

<style scoped>
.v-file-input {
  margin-bottom: 1.6rem;
}

.v-file-input__label {
  display: block;
  margin-bottom: 0.8rem;
  font-size: 1.4rem;
  font-weight: 500;
  color: #424242;
}

.v-file-input__wrapper {
  position: relative;
}

.v-file-input__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.v-file-input__upload-label {
  font-size: 1.2rem;
  color: #9e9e9e;
  margin-bottom: 0.6rem;
}

.v-file-input__display {
  width: 100%;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.v-file-input__button {
  background-color: #e0f5e9;
  width: 100%;
  padding: 1.2rem 2rem;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  transition: background-color 0.2s ease;
  position: relative;
}

.v-file-input__button:hover {
  background-color: #c8ebd8;
}

.v-file-input__inline-preview {
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.4rem;
  object-fit: cover;
}

.v-file-input__button-text {
  font-size: 1.6rem;
  font-weight: 600;
  color: #000;
}

.v-file-input__remove-button {
  background: none;
  border: none;
  color: #333;
  cursor: pointer;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-file-input__remove-button:hover {
  color: #f44336;
}

.v-file-input__hint {
  margin-top: 0.4rem;
  font-size: 1.2rem;
  line-height: 1.4;
  color: #757575;
}

.v-file-input__hint--error {
  color: #f44336;
}
</style>